import React, {FC} from 'react'
import styled from 'styled-components'
import {theme} from '../theme'

const ElectionLogoBase: FC = () => {
  return (
    <LogoContainer className="election-logo-container">
      <Header
        src="https://assets.ilcdn.fi/dcd77429c2959f798bc0b07168c04d9b8ed3ca4ca10882c4e45d281cd9a6da73.svg"
        alt={'Kunta- ja aluevaalit 2024 -logo'}
      />
    </LogoContainer>
  )
}

const LogoContainer = styled.div`
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
`

const Header = styled.img`
  width: 310px;
  @media screen and (max-width: ${theme.breakPoints.mobileLandscape}px) {
    width: 260px;
  }
`

export const ElectionLogo = styled(ElectionLogoBase)``
